import { lazyLoad } from 'utils/loadable';

export const ProfileSettings = lazyLoad(
  () => import('./index'),
  module => module.default,
); 